import { Theme } from '@mui/material'
import { Components } from '@mui/material/styles/components'

export const C1ButtonGroupTheme: Components<Theme>['MuiButtonGroup'] = {
    defaultProps: {
        disableElevation: true,
        disableRipple: true,
        disableFocusRipple: true,
    },
    styleOverrides: {
        grouped: ({ ownerState, theme }) => theme.unstable_sx({
            maxHeight: '30px',
            minWidth: '30px',
            ...(ownerState.variant === 'contained' && {
                ':not(:last-of-type)': {
                    borderColor: 'primary.light',
                },
            }),

            ...(ownerState.variant === 'outlined' && {
                '&:not(:disabled) + :disabled:last-of-type': {
                    borderLeft: '1px solid',
                    borderLeftColor: `${ownerState.color}.main`,
                },
            }),
        }),
        firstButton: ({ ownerState, theme }) => theme.unstable_sx({
            '&:active, &:focus': {
                borderRight: '1px solid',
                borderRightColor: `${ownerState.color}.main`,
                zIndex: 1,
            },
            '&:hover': {
                borderRight: '1px solid',
                borderRightColor: 'info.main',
                zIndex: 1,
            },
        }),
        middleButton: ({ ownerState, theme }) => theme.unstable_sx({
            '&:active, &:focus': {
                borderRight: '1px solid',
                borderRightColor: `${ownerState.color}.main`,
                zIndex: 1,
            },
            '&:hover': {
                borderRight: '1px solid',
                borderRightColor: 'info.main',
                zIndex: 1,
            },
        }),
    },
}
